import Vuex, { Store } from 'vuex'

import { setup, rootMutation as localMutation } from './local'
import accountConfirmationRequests from './modules/accountConfirmationRequests'
import accountConfirmations from './modules/accountConfirmations'
import accountReferrers from './modules/accountReferrers'
import accountTenancy from './modules/accountTenancy'
import accounts from './modules/accounts'
import admin from './modules/admin'
import affiliateSales from './modules/affiliateSales'
import affiliatePayments from './modules/affiliatePayments'
import billingPortal from './modules/billingPortal'
import braintreeClient from './modules/braintreeClient'
import checkout from './modules/checkout'
import community from './modules/community'
import cookiePreferences from './modules/cookiePreferences'
import customize from './modules/customize'
import discounts from './modules/discounts'
import docs from './modules/docs'
import flashMessages from './modules/flashMessages'
import githubLinks from './modules/githubLinks'
import iconCollections from './modules/iconCollections'
import iconDefinitions from './modules/iconDefinitions'
import iconPopularityList from './modules/iconPopularityList'
import iconUploads from './modules/iconUploads'
import invoices from './modules/invoices'
import kickstarterBackers from './modules/kickstarterBackers'
import kits from './modules/kits'
import kitPackages from './modules/kitPackages'
import licenses from './modules/licenses'
import metaSocial from './modules/metaSocial'
import modals from './modules/modals'
import orders from './modules/orders'
import pageviewDomains from './modules/pageviewDomains'
import passwordResetRequests from './modules/passwordResetRequests'
import passwordResets from './modules/passwordResets'
import paypalBillingAgreement from './modules/paypalBillingAgreement'
import permits from './modules/permits'
import plans from './modules/plans'
import planOverrides from './modules/admin/planOverrides'
import products from './modules/products'
import profiles from './modules/profiles'
import reports from './modules/reports'
import seatAssignments from './modules/seatAssignments'
import sessions from './modules/sessions'
import subscriptions from './modules/subscriptions'
import tokens from './modules/tokens'
// TODO: metered billing WIP
import meteredBilling from './modules/meteredBilling'

export let instance = null

/**
 * A function that creates a Vuex store and registers it as a global component.
 *
 * Convenience Links:
 * {@link https://v3.vuex.vuejs.org/guide/#the-simplest-store Vuex Simple Store}
 * {@link https://v2.vuejs.org/v2/guide/components-registration.html Registration}
 * {@link https://v2.vuejs.org/v2/api/#Vue-use Vue Use Plugin}
 *
 * @function
 * @param {Vue} vueInstance - An instance of the Font Awesome VueJS application
 */
export default (vueInstance) => {
  vueInstance.use(Vuex)

  const store = new Store({
    strict: FONTAWESOME.ENV !== 'production',

    mutations: {
      ...localMutation
    },

    modules: {
      accountConfirmationRequests,
      accountConfirmations,
      accountReferrers,
      accountTenancy,
      accounts,
      admin,
      affiliatePayments,
      affiliateSales,
      billingPortal,
      braintreeClient,
      checkout,
      community,
      cookiePreferences,
      customize,
      discounts,
      docs,
      flashMessages,
      githubLinks,
      iconCollections,
      iconDefinitions,
      iconPopularityList,
      iconUploads,
      invoices,
      kickstarterBackers,
      kits,
      kitPackages,
      licenses,
      metaSocial,
      // TODO: metered billing WIP
      meteredBilling,
      modals,
      orders,
      pageviewDomains,
      passwordResetRequests,
      passwordResets,
      paypalBillingAgreement,
      permits,
      plans,
      planOverrides,
      products,
      profiles,
      reports,
      seatAssignments,
      sessions,
      subscriptions,
      tokens
    }
  })

  setup(store)

  instance = store

  return store
}
